import { Controller } from "stimulus";
import Flatpickr from "flatpickr";

export default class extends Controller {
  static targets = ["dateRangeStart", "dateRangeEnd"];

  connect() {
    var link = document.createElement("link");
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("type", "text/css");
    link.setAttribute("href", "https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css");
    document.getElementsByTagName("head")[0].appendChild(link);

    Flatpickr(this.dateRangeStartTarget, {
      onChange: (dates, dateStr) => {
        const params = new URLSearchParams(window.location.search);
        params.set("start_date", dateStr);
        params.set("end_date", this.dateRangeEndTarget.value);
        window.location.search = params.toString();
      }
    });

    Flatpickr(this.dateRangeEndTarget, {
      onChange: (dates, dateStr) => {
        const params = new URLSearchParams(window.location.search);
        params.set("start_date", this.dateRangeStartTarget.value);
        params.set("end_date", dateStr);
        window.location.search = params.toString();
      }
    });
  }
}
